export default "__VITE_ASSET__CcRFW4IB__"